import GeneralModel from "./../../../general/GeneralModel";
import Category from "./Category";
import CategoriesFilter from "./CategoriesFilter";

export default class Categories extends GeneralModel {
  constructor() {
    super();
    this.setInitialValue();
  }
  setInitialValue() {
    this.setGeneralModelInitialValue();
    this.categoriesData = [];
    this.category = new Category();
    this.filterData = new CategoriesFilter();
  }
  fillData(data) {
    if (data) {
      this.fillGeneralModelData(data);
      this.categoriesData = data.categoriesData || [];
      let filter = { ...this.filterData, ...data.pagination };
      this.filterData.fillData(filter);
    } else {
      this.setInitialValue();
    }
  }
}
